import { sellItemIds } from './sellItems';

export type SubscriptionPlan = {
    id: typeof sellItemIds[keyof typeof sellItemIds]
    name: string
    jobs?: number
    monthlyPrice: number
    promoMonthlyPrice?: number
    popular?: boolean
    subtitle?: string
    contactOnly?: boolean
    customPriceText?: string
    featureTitle?: string
    customFeatures?: string[]
}

export type BillingPeriod = 'monthly' | 'annual';

export const SUBSCRIPTION_PLANS: Record<BillingPeriod, SubscriptionPlan[]> = {
    annual: [
        {
            id: sellItemIds.subscriptionStarterAnnual,
            name: 'משרה אחת',
            monthlyPrice: 290,
            promoMonthlyPrice: 180,
            jobs: 1,
        },
        {
            id: sellItemIds.subscriptionProAnnual,
            name: '4 משרות',
            monthlyPrice: 440,
            jobs: 4,
        },
        {
            id: sellItemIds.subscriptionBusinessAnnual,
            name: '5 משרות ומעלה',
            monthlyPrice: 0,
            subtitle: 'פתרון מותאם אישית',
            contactOnly: true,
            customPriceText: 'בואו נדבר 💬',
            featureTitle: 'כל מה שיש במסלולים + הטבות מיוחדות:',
            customFeatures: [
                'לוגו העסק מוצג על המשרה',
                'דף נחיתה לעסק',
                'סריקת משרות מהאתר שלכם',
                'ועוד הטבות בהתאמה אישית',
            ],
        },
    ],
    monthly: [
        {
            id: sellItemIds.subscriptionStarterMonthly,
            name: 'משרה אחת',
            monthlyPrice: 290,
            promoMonthlyPrice: 180,
            jobs: 1,
        },
        {
            id: sellItemIds.subscriptionProMonthly,
            name: '4 משרות',
            monthlyPrice: 440,
            jobs: 4,
        },
        {
            id: sellItemIds.subscriptionBusinessMonthly,
            name: '5 משרות ומעלה',
            monthlyPrice: 0,
            subtitle: 'פתרון מותאם אישית',
            contactOnly: true,
            customPriceText: 'בואו נדבר 💬',
            featureTitle: 'כל מה שיש במסלולים + הטבות מיוחדות:',
            customFeatures: [
                'לוגו העסק מוצג על המשרה',
                'דף נחיתה לעסק',
                'סריקת משרות מהאתר שלכם',
                'ועוד הטבות בהתאמה אישית',
            ],
        },
    ],
};

export const SUBSCRIPTION_PLAN_FEATURES = [
    'עדיפות גבוהה במנוע החיפוש בוואטסאפ',
    'דיוור ישיר למועמדים רלוונטיים',
    'התאמת קורות חיים איכותיים ע"י סוכן AI',
];

export const SUBSCRIPTION_MONTHLY_FEATURE = 'ניתן לבטל בכל עת';

export const SUBSCRIPTION_ANNUAL_FEATURE = '25% הנחה (התחייבות שנתית)';

export const getSubscriptionJobsLabel = (jobs?: number) => (
    jobs === 1 ? 'משרה אחת' : `${jobs} משרות`
);

export const getAnnualTotal = (monthlyPrice: number) => monthlyPrice * 9;

export const getEffectiveMonthly = (monthlyPrice: number) => Math.round((monthlyPrice * 9) / 12);

export const getAnnualSavings = (monthlyPrice: number) => monthlyPrice * 3;
